import httpClient from '@/http-client'

export const store = data => {
  return httpClient
    .post('/api/v1/product-label', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const printBarcode = data => {
  return httpClient
    .post('/api/v1/product-label/barcodes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProductSerial = data => {
  return httpClient
    .post('/api/v1/product-label/product-serials', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getProductBarcode = (Options = {}) => {
  return httpClient
    .get(`/api/v1/product-label/product-barcodes`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getStockIn = (Options = {}) => {
  return httpClient
    .get(`/api/v1/product-label/stock-in`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProductProfile = data => {
  return httpClient
    .post('/api/v1/product-label/product-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export const getCategory = (Options = {}) => {
  return httpClient
    .get(`/api/v1/product-label/categories`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { 
  store, 
  getProductSerial, 
  getStockIn, 
  getProductBarcode, 
  printBarcode, 
  getProductProfile,
  getCategory
}
